import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { xor } from 'lodash';
import { selectSimplifiedEmployees } from '../../../../modules/employees.js';
import { navigateToProjectReports } from '../../../links/index.jsx';
import EmployeesCombobox from '../../../employees-form-field/EmployeesCombobox.jsx';

const mapStateToProps = (state) => ({
  employees: selectSimplifiedEmployees(state),
});

EmployeesFilter.propTypes = {
  disabled: PropTypes.bool,
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      fullName: PropTypes.string.isRequired,
    })
  ),
  selectedEmployeeIds: PropTypes.arrayOf(PropTypes.number),
};

function EmployeesFilter(props) {
  const handleSelect = (employee) => {
    const { id } = employee;
    navigateToProjectReports({
      employees: id ? xor(props.selectedEmployeeIds, [id]) : [],
    });
  };

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Employees</div>
      <EmployeesCombobox
        {...props}
        handleSelect={handleSelect}
        navigateAction={navigateToProjectReports}
      />
    </div>
  );
}

export default connect(mapStateToProps)(EmployeesFilter);
